import axios from "axios";

const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addCartItem = async (token, data) => {
  const url = `${BASE_URL}/carts/create_cart_item/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  console.log();
  

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllCartItems = async (token, userId) => {
  const url = `${BASE_URL}/carts/cart/${userId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateCartItem = async (token, data, cartId, cartItemId) => {
  const url = `${BASE_URL}/carts/update_cart_item/${cartId}/${cartItemId}/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.patch(url, data, config);
    return response;
  } catch (error) {
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const deleteCartItem = async (token, cartId, cartItemId) => {
  const url = `${BASE_URL}/carts/update_cart_item/${cartId}/${cartItemId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

